module.exports = __webpack_public_path__ + "static/media/app-logo.639db707.png";